import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center pt-16">
        <div className="text-center px-4">
          <span className="w-24 h-24 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-6">
            <i className="ri-movie-2-line text-4xl"></i>
          </span>
          <h1 className="text-5xl md:text-6xl font-black font-heading text-foreground-950 mb-3">404</h1>
          <p className="text-lg text-foreground-500 mb-2">哎呀，这个页面走丢了...</p>
          <p className="text-sm text-foreground-400 mb-8">该页面可能已被移除或链接地址有误</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}